"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _metrics = require("../../_helpers/metrics");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./InputChip.css");

var _styles = {
  "input-chip": "InputChip__input-chip___2azaB",
  "selected": "InputChip__selected___3dQFk"
};

const styles = _bind.default.bind(_styles);

const InputChip = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  text,
  onClick,
  textSize,
  selected,
  disabled,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('input-chip', {
    selected
  }), className);
  return _react.default.createElement("button", {
    "data-testid": dataTestId,
    className: composed_classname,
    disabled: disabled,
    onClick: () => {
      if (dataTestId) {
        (0, _metrics.trackAction)(`click on ${dataTestId}`);
      }

      onClick();
    },
    ...props
  }, _react.default.createElement(_.Text, {
    tag: 'span',
    size: textSize,
    text: text,
    color: 'inherit',
    variant: 'medium'
  }));
});
var _default = InputChip;
exports.default = _default;